module.exports = __webpack_public_path__ + "static/img/picpay.30a6bc5d.svg";